import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'm-detail',
    templateUrl: './detail.component.html'
})
export class DetailComponent implements OnInit {

    @Input() data: any;
    constructor() {
    }

    ngOnInit(): void {

    }

    toogle(item) {
        if (item.expand) {
            item.expand = !item.expand;

            return;
        }

        this.data.detailContent.forEach(element => {
            if (element.expand) {
                element.expand = false;
            }
        });

        item.expand = true;
    }
}
